// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";
import * as JsxRuntime from "react/jsx-runtime";

function mkBool(label, x) {
  if (x) {
    return label;
  } else {
    return "";
  }
}

function mkTaskRows(tasks, taskLengths) {
  const n = Caml.caml_int_min(tasks.length, taskLengths.length);
  return Stdlib__Array.init(n, (function (i) {
    const t = Caml_array.get(tasks, i);
    const d = Caml_array.get(taskLengths, i);
    return {
      taskName: t.taskName,
      tps: Stdlib__String.concat("-", Stdlib__Array.to_list(Stdlib__Array.map((function (z) {
        return z.zoneName;
      }), t.zones.raw))),
      distance: d,
      stopped: Stdlib__Option.is_some(t.stopped),
      cancelled: Stdlib__Option.value(t.cancelled, false)
    };
  }));
}

function s(prim) {
  return prim;
}

function CompTasks$TaskRow(Props) {
  let row = Props.row;
  return JsxRuntime.jsxs("tr", {
    children: [
      JsxRuntime.jsx("td", {
        children: "1"
      }),
      JsxRuntime.jsx("td", {
        children: row.taskName,
        className: "td-task-name"
      }),
      JsxRuntime.jsx("td", {
        children: row.tps,
        className: "td-task-tps"
      }),
      JsxRuntime.jsx("td", {
        children: row.distance,
        className: "td-task-dist"
      }),
      JsxRuntime.jsx("td", {
        children: row.stopped ? "STOPPED" : "",
        className: "td-task-stopped"
      }),
      JsxRuntime.jsx("td", {
        children: row.cancelled ? "CANCELLED" : "",
        className: "td-task-cancelled"
      })
    ]
  });
}

const TaskRow = {
  make: CompTasks$TaskRow
};

function CompTasks(Props) {
  let compTasks = Props.compTasks;
  let taskLengths = Props.taskLengths;
  const xs = Stdlib__Array.mapi((function (i, row) {
    const Key = String(i);
    return JsxRuntime.jsx(CompTasks$TaskRow, {
      row: row
    }, Key);
  }), mkTaskRows(compTasks, taskLengths));
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsxs("table", {
        children: [
          JsxRuntime.jsx("thead", {
            children: JsxRuntime.jsxs("tr", {
              children: [
                JsxRuntime.jsx("th", {
                  children: "#"
                }),
                JsxRuntime.jsx("th", {
                  children: "Name",
                  className: "th-task-name"
                }),
                JsxRuntime.jsx("th", {
                  children: "Turnpoints",
                  className: "th-task-tps"
                }),
                JsxRuntime.jsx("th", {
                  children: "Distance",
                  className: "th-task-dist"
                }),
                JsxRuntime.jsx("th", {
                  children: "Stopped",
                  className: "th-task-stopped"
                }),
                JsxRuntime.jsx("th", {
                  children: "Cancelled",
                  className: "th-task-cancelled"
                })
              ]
            })
          }),
          JsxRuntime.jsx("tbody", {
            children: xs
          })
        ],
        className: "table is-striped"
      })]
  });
}

const make = CompTasks;

export {
  mkBool,
  mkTaskRows,
  s,
  TaskRow,
  make,
}
/* react/jsx-runtime Not a pure module */
